// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz1fxt{color:var(--ds-text,#172b4d)}\n._syaz1lh4{color:var(--ds-text-disabled,#091e424f)}", ""]);
// Exports
module.exports = exports;
